import React, { Component } from "react";
import { connect } from "react-redux";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import Auto from "../autocomplete/autocomplete";
import PickDropAuto from "../autocomplete/pickDropAutoComplete";
import { CalendarIcon, ReverseIcon, SwapIcon, CalendarIconBlue } from "../common/icons/svg";
import { apiUrl } from "../common/constants";
import {
  findKey,
  getRevDate,
  getDateForSrch,
  fetchGet,
} from "../../common/common";
import { updateStaticCityList, updateCityList } from "../../actions/search-actions";
import store from "../../store";
import { renderImg } from "../common/icons/img";
import Checkbox from "../common/input/checkbox";
import { t, STARTING_FROM, GOING_TO, JOURNEY_DATE, RETURN_DATE, SINGLE_LADY, MODIFY, CHO0SE_DATE, OPTIONAL } from "../../translations/Modify";

class Modify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevLink: "",
      nextLink: "",
      from: this.props.search.searchParams.fromCity.split("|")[1],
      to: this.props.search.searchParams.toCity.split("|")[1],
      staticCityList: {},
      cityList: {},
      fromList: [],
      toList: [],
      boardingList: [],
      droppingList: [],
      boardingPoint: this.props.search.searchParams.stationInFromCity ? this.props.search.searchParams.stationInFromCity.split("|")[0].replace(/[^a-zA-Z]/g, " ") : '',
      droppingPoint: this.props.search.searchParams.stationInToCity ? this.props.search.searchParams.stationInToCity.split("|")[0].replace(/[^a-zA-Z]/g, " ") : '',
      focused: false,
      retFocused: false,
      fromErr: false,
      toErr: false,
      depErr: false,
      swapErr: false,
      depDate: moment(
        new Date(getRevDate(this.props.search.searchParams.departDate))
      ),
      retDate:
        this.props.search.searchParams.mode === "oneway"
          ? null
          : this.props.search.searchParams.returnDate ? moment(
            new Date(getRevDate(this.props.search.searchParams.returnDate))
          ) : null,
      alerterror: "",
      singleLady: this.props.search.searchParams.IsSingleLady == 1 ? 1 : 0,
      singleLadyDisabled:(this.props.search.searchParams.IsSingleLady==1 && this.props.search.searchParams.mode=="roundtrip" && this.props.search.searchParams.token) ? 1 : 0,
    };
  }

  componentDidMount() {
    const that = this;
    /* const url = window.url + apiUrl.getcities;
    fetchGet(url)
      .then(function (data) {
        const cityList = data;
        let fromList = [];
        let toList = [];
        Object.keys(data).forEach((el, index) => {
          fromList.push(data[el].Name);

          const fromCityKey = Object.keys(cityList).find(
            (key) =>
              cityList[key].Name ===
              that.props.search.searchParams.fromCity.split("|")[1]
          );

          if (el === fromCityKey) {
            Object.keys(data[el].ToCities).forEach((val) =>
              toList.push(data[el].ToCities[val])
            );
          }
        });
        that.setState({ cityList, fromList, toList });
      })
      .catch(function (error) {
        console.log(error);
      });  */
    // if (Object.keys(this.props.search.staticCityList).length === 0) {
    this.getStaticCityList();
    // }
    this.parseNextPrevLinks();
    // to gather the pickup and dropoffs to show in search section
    // that.loadPickStations(that.props.search.searchParams.fromCity.split("|")[0]);
    // that.loadDropStations(that.props.search.searchParams.toCity.split("|")[0]);
  }

  parseStaticCityList = (staticCityList) => {
    let that = this;
    let cityList = {};
    let fromList = [];
    let toList = [];

    Object.entries(staticCityList).forEach(([index, cityObj]) => {
      cityList[index] = { Name: cityObj.Name, Key: cityObj.Key, ID: cityObj.ID, ToCities: staticCityList };
      fromList.push({ Name: cityObj.Name, Key: cityObj.Key, ID: cityObj.ID });
      toList.push({ Name: cityObj.Name, Key: cityObj.Key, ID: cityObj.ID });
    });

    that.setState({ staticCityList, cityList, fromList, toList });
  }

  getStaticCityList = () => {
    const that = this;

    if (Object.keys(that.props.search.staticCityList).length > 0) {
      const staticCityList = that.props.search.staticCityList;
      that.parseStaticCityList(staticCityList);
      setTimeout(() => {
        that.getCityList();
      }, 100)
    } else {
      const url = window.cdnUrl + apiUrl.getStaticCity;
      fetchGet(url)
        .then(function (response) {

          if (response.success) {

            const staticCityList = response.data;
            store.dispatch(updateStaticCityList(staticCityList));
            that.parseStaticCityList(staticCityList);
            that.getCityList();

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }


  parseCityList = (cityResData) => {
    let that = this;
    const staticCityList = that.state.staticCityList;
    const staticCityList2 = that.state.staticCityList;
    let cityList = {};
    let fromList = [];
    let toList = [];
    let index = 0;

    Object.entries(cityResData).forEach(([frCityId, toCitiesArr]) => {
      Object.entries(staticCityList).forEach(([i, stCity]) => {

        //for find fromcity object by matching cityid
        if (stCity.ID == frCityId) {
          const frCityObj = stCity;
          const ToCities = [];

          //for fromcity create tocities object data
          toCitiesArr.forEach((toCityId) => {
            Object.entries(staticCityList2).forEach(([j, stToCity]) => {
              if (stToCity.ID == toCityId) {
                ToCities.push(stToCity);
              }
            });
          });

          //for create citylist array with fromcity object and tocites object date
          cityList[index] = { Name: frCityObj.Name, Key: frCityObj.Key, ID: frCityObj.ID, ToCities: ToCities };

          //for create fromcity object list
          fromList[index] = { Name: frCityObj.Name, Key: frCityObj.Key, ID: frCityObj.ID };

          //for selected fromcity create tocities object data
          if (frCityObj.Name == that.props.search.searchParams.fromCity.split("|")[1]) {
            toList = ToCities;
          }

          index++;
        }
      });
    });

    that.setState({ cityList, fromList, toList });
  }

  getCityList = () => {
    const that = this;

    if (Object.keys(that.props.search.cityList).length > 0) {
      const cityResData = that.props.search.cityList;
      that.parseCityList(cityResData)

    } else {
      const url = window.cdnUrl + apiUrl.getCityList;
      fetchGet(url)
        .then(function (cityResponse) {

          if (cityResponse.success) {
            const cityResData = cityResponse.data;
            store.dispatch(updateCityList(cityResData));
            that.parseCityList(cityResData)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  loadPickStations = (fromCityId) => {
    const that = this;
    const url = window.url + apiUrl.getPickStations + "?fromCityId=" + fromCityId;
    fetchGet(url)
      .then(function (data) {
        // console.log("pickStations", data);
        that.setState({ boardingList: [...data] })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  loadDropStations = (toCityId) => {
    const that = this;
    const url = window.url + apiUrl.getDropStaions + "?toCityId=" + toCityId;
    fetchGet(url)
      .then(function (data) {
        that.setState({ droppingList: [...data] })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  parseNextPrevLinks = () => {
    const departDate = new Date(
      getRevDate(this.props.search.searchParams.departDate)
    );
    const currDate = new Date(new Date(window.today).toDateString());
    let tomorrow = new Date(departDate);
    let yesterday = new Date(departDate);
    let dayBeforeTomorrow = new Date(departDate);
    let maxDate = new Date(window.today);
    maxDate.setDate(new Date(maxDate.getDate() + window.daysForCalendar));
    tomorrow.setDate(departDate.getDate() + 1);
    yesterday.setDate(departDate.getDate() - 1);
    // console.log("maxDate", maxDate.getDate());
    // console.log("dayBeforeTomorrow", dayBeforeTomorrow.getDate());
    // console.log(maxDate.getDate() === dayBeforeTomorrow.getDate());
    const prevLink =
      currDate < yesterday ? this.getSearchUrl(yesterday) : false;
    const nextLink = (dayBeforeTomorrow.getDate() === maxDate.getDate() && dayBeforeTomorrow.getMonth() === maxDate.getMonth()) ? false : this.getSearchUrl(tomorrow);
    this.setState({ prevLink, nextLink });
  };

  getSearchUrl = (val) => {
    const dt = "departDate=" + this.getFormattedDateForURL(val);
    let srchUrl = "/search/";
    const srchParams = window.location.search;
    let tempDt =
      srchParams.indexOf("departDate=") >= 0
        ? srchParams.split("departDate=")
        : false;
    tempDt[1] =
      tempDt[1].indexOf("&") >= 0
        ? tempDt[1].substr(tempDt[1].indexOf("&"))
        : "";
    srchUrl += tempDt[0] + dt + tempDt[1];

    if (this.state.singleLady == 1) {
      srchUrl += '&IsSingleLady=1';
    } else {
      srchUrl += '&IsSingleLady=0';
    }
    return srchUrl;
  };

  getFormattedDateForURL = (dateString) => {
    //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
    const d = dateString;
    let day = d.getDate(),
      month = d.getMonth() + 1,
      year = d.getFullYear();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;

    return day + "-" + month + "-" + year;
  };

  setFrom = (from, param, type = '') => {
    let toList = param ? [] : this.state.toList;
    if (param) {
      const cityList = this.state.cityList;
      if (from === "") {
        const list = cityList[Object.keys(cityList)[0]].ToCities;
        Object.keys(list).forEach((el) => toList.push(list[el]));
      } else {
        const key = findKey(cityList, from, "Name");
        if (cityList[key] !== undefined) {
          const list = cityList[key].ToCities;
          Object.keys(list).forEach((el) => toList.push(list[el]));
        }
        if (type !== 'swap')
          // this.loadPickStations(key);
          if (type === 'selCity') {
            this.setState({ to: '' });
          }
        if (type === 'swap') {
          this.setState({ boardingPoint: '', droppingPoint: '' })
        }
      }
    }
    if (param === "true") {

      const fromCityObj = Object.values(toList).find((el) => {
        return el.Name === this.state.from;
      });

      if (fromCityObj === undefined) {
        from = this.state.from;
        const to = this.state.to;
        toList = this.state.toList;
        this.setState({
          from,
          toList,
          to,
          swapErr: true,
          alerterror: to + " to " + from + " route is not available.",
        });
      } else {
        this.setState({ from, toList, to: this.state.from });
      }
    } else {
      // this.setState({ from, toList, to: toList[0] || this.state.to, boardingPoint: '' });
      this.setState({ from, toList, boardingPoint: '' });
    }
  };

  setTo = (to, param) => {
    let fromCityKey, toCityKey = 0;
    fromCityKey = Object.keys(this.state.cityList).find(
      (key) => this.state.cityList[key].Name === this.state.from
    );
    toCityKey =
      fromCityKey &&
      Object.keys(this.state.cityList[fromCityKey].ToCities).find(
        (key) => this.state.cityList[fromCityKey].ToCities[key] === to
      );
    if (toCityKey) {
      this.loadDropStations(toCityKey);
    }
    this.setState({ to, droppingPoint: '' });
  };

  setBoardingPoint = (val) => {
    this.setState({ boardingPoint: val })
  }

  setDropingPoint = (val) => {
    this.setState({ droppingPoint: val })
  }

  checkOutsideRange = (param, e) => {
    //console.log("hello");
    let today = new Date(window.today);
    today.setHours(0, 0, 0, 0);
    let ninety = new Date(window.today);
    ninety = ninety.setDate(ninety.getDate() + window.daysForCalendar);
    if (param === "dep") {
      return !(today <= e._d && ninety > e._d);
    } else {
      if (this.state.depDate && this.state.depDate._d) {
        const depDate = this.state.depDate._d;
        return !(depDate <= e._d && ninety > e._d);
      } else {
        return !(today <= e._d && ninety > e._d);
      }
    }
  };

  swapCities = () => {
    // const from = this.state.from;
    const to = this.state.to.replace("+", " ");
    this.setFrom(to, "true", 'swap');
    // this.setTo('', false);

    let fromCityKey, toCityKey = 0;

    /* fromCityKey = Object.keys(this.state.cityList).find(
      (key) => this.state.cityList[key].Name === this.state.from
    );
    toCityKey =
      fromCityKey &&
      Object.keys(this.state.cityList[fromCityKey].ToCities).find(
        (key) => this.state.cityList[fromCityKey].ToCities[key] === to
      ); */

    const fromCityObj = Object.values(this.state.cityList).find((el) => {
      return el.Name === this.state.from;
    });

    const toCityObj = fromCityObj && Object.values(fromCityObj.ToCities).find((el) => {
      return el.Name === to;
    });

    if (fromCityObj != undefined) {
      fromCityKey = fromCityObj.ID;
    }

    if (toCityObj != undefined) {
      toCityKey = toCityObj.ID;
    }

    // this.loadPickStations(toCityKey);
    // this.loadDropStations(fromCityKey);
  };

  modifySrch = () => {
    const from = this.state.from.replace("+", " ");
    const to = this.state.to.replace("+", " ");
    const departDate = this.state.depDate ? this.state.depDate._d : false;
    const returnDate = this.state.retDate ? this.state.retDate._d : false;
    const boardingList = this.state.boardingList;
    const droppingList = this.state.droppingList;
    let url = '';
    let fromStation, toStation, fromStationKey, tostationKey = '';
    if (!from || !to || !departDate) {
      let fromErr = !from ? true : false;
      let toErr = !to ? true : false;
      let depErr = !departDate ? true : false;
      this.setState({ fromErr, toErr, depErr });
      return;
    } else {
      const mode = !returnDate ? "oneway" : "roundtrip";

      const fromCityObj = Object.values(this.state.cityList).find((el) => {
        return el.Name === from;
      });

      const toCityObj = fromCityObj && Object.values(fromCityObj.ToCities).find((el) => {
        return el.Name === to;
      });

      let fromCityKey = 0;
      let toCityKey = 0;

      if (fromCityObj != undefined) {
        fromCityKey = fromCityObj.ID;
      }

      if (toCityObj != undefined) {
        toCityKey = toCityObj.ID;
      }

      fromStation = boardingList && boardingList.filter(el => el.PickupName.toLowerCase() === this.state.boardingPoint.toLowerCase())[0];
      toStation = boardingList && droppingList.filter(el => el.DropOffName.toLowerCase() === this.state.droppingPoint.toLowerCase())[0];
      fromStationKey = (fromStation ? fromStation.PickupName : '') + '|' + (fromStation ? fromStation.PickupIDs : '');
      tostationKey = (toStation ? toStation.DropOffName : '') + '|' + (toStation ? toStation.DropOffIDs : '');

      if (fromStationKey !== '|') {
        fromStationKey = fromStationKey;
      } else {
        fromStationKey = '';
      }
      if (tostationKey !== '|') {
        tostationKey = tostationKey;
      } else {
        tostationKey = '';
      }
      // console.log(fromStationKey)
      // console.log(tostationKey)
      if (fromCityKey && toCityKey) {
        const fromCity = fromCityKey + "|" + from;
        const toCity = toCityKey + "|" + to;
        const depD = getDateForSrch(departDate);
        const retD = !returnDate
          ? ""
          : "&returnDate=" + getDateForSrch(returnDate);
        url =
          "/search?mode=" +
          mode +
          "&fromCity=" +
          fromCity +
          "&toCity=" +
          toCity +
          "&departDate=" +
          depD +
          retD +
          "&stationInFromCity=" + fromStationKey +
          "&stationInToCity=" + tostationKey;
        // if (fromCityKey && toCityKey && (fromStationKey == '' && tostationKey == '')) {
        //   const fromCity = fromCityKey + "|" + from;
        //   const toCity = toCityKey + "|" + to;
        //   const depD = getDateForSrch(departDate);
        //   const retD = !returnDate
        //     ? ""
        //     : "&returnDate=" + getDateForSrch(returnDate);
        //   url =
        //     "/search?mode=" +
        //     mode +
        //     "&fromCity=" +
        //     fromCity +
        //     "&toCity=" +
        //     toCity +
        //     "&departDate=" +
        //     depD + retD +
        //     "&stationInFromCity=" + fromStationKey +
        //     "&stationInToCity=" + tostationKey;
        // }
        if (this.state.singleLady == 1) {
          url += '&IsSingleLady=1';
        } else {
          url += '&IsSingleLady=0';
        }
        window.location.href = url;

      } else {
        this.setState({
          alerterror: to + " to " + from + " route is not available.",
        });
      }
    }
  };
  showaertdialogue = () => {
    setTimeout(() => {
      this.setState({ alerterror: "" });
    }, 5000);
    return (
      <div
        className="blacklayer"
        onClick={() => {
          this.setState({ alerterror: "" });
        }}
      >
        <div className="popupbox">
          <div className="alertmsg">{this.state.alerterror}</div>
          <button
            className="alertbuttonok crsrpointer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            OK{" "}
          </button>
        </div>
      </div>
    );
  };

  render() {

    let that = this;
    return (
      <section className="searchformsection">
        {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
        <div className="searchbar">
          <Auto
            className="Fromcity cityinput"
            list={this.state.fromList}
            placeholder={t(STARTING_FROM)}
            value={this.state.from}
            setValue={this.setFrom}
            err={this.state.fromErr}
            label={t(STARTING_FROM)}
            inputpadding="34px 15px 17px 23px"
            spanclassname="mod-clear flex-vc"
          />
          <div className="swap-ico" onClick={this.swapCities}>
            {/* <SwapIcon /> */}
            {renderImg('SwapIcon')}
          </div>
          <PickDropAuto
            className={`Fromcity cityinput pickup--input ${this.state.boardingPoint ? 'filled' : ''}`}
            list={this.state.boardingList}
            placeholder={`Stations in ${this.state.from}`}
            value={this.state.boardingPoint}
            setValue={this.setBoardingPoint}
            err={this.state.toErr}
            label={`Stations in ${this.state.from}`}
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
            boardingStation={this.state.boardingPoint}
            type={'boardingStation'}
          />
          <Auto
            className="Tocity cityinput"
            list={this.state.toList}
            placeholder={t(GOING_TO)}
            value={this.state.to}
            setValue={this.setTo}
            err={this.state.toErr}
            label={t(GOING_TO)}
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
          />
          <PickDropAuto
            className={`Tocity cityinput dropout--input ${this.state.droppingPoint ? 'filled' : ''}`}
            list={this.state.droppingList}
            placeholder={`Stations in ${this.state.to}`}
            value={this.state.droppingPoint}
            setValue={this.setDropingPoint}
            err={this.state.toErr}
            label={`Stations in ${this.state.to}`}
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
            dropingStation={this.state.droppingPoint}
            type={'dropingStation'}
          />
          <div
            className={
              this.state.depErr ? "mo-inp err cityinput" : "mo-inp cityinput"
            }
          >
            <SingleDatePicker
              id="onwardjdate"
              readOnly={true}
              date={this.state.depDate} // momentPropTypes.momentObj or null
              onDateChange={(depDate) =>
                this.setState({ depDate, retDate: null })
              } // PropTypes.func.isRequired
              focused={this.state.focused} // PropTypes.bool
              onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
              hideKeyboardShortcutsPanel={true}
              block={true}
              numberOfMonths={2}
              noBorder={true}
              displayFormat="ddd MMM  DD YYYY"
              placeholder="Choose date"
              isOutsideRange={(event) => this.checkOutsideRange("dep", event)}
              anchorDirection="left"
              firstDayOfWeek={0}
            />
            <span className="mod-clear calendar">
              {/* <CalendarIcon /> */}
              {renderImg('CalendarIconBlue')}
            </span>
            <label>{t(JOURNEY_DATE)}</label>
          </div>
          <div className="mo-inp cityinput">
            <SingleDatePicker
              id="returnjdate"
              readOnly={true}
              date={this.state.retDate} // momentPropTypes.momentObj or null
              onDateChange={(retDate) => this.setState({ retDate })} // PropTypes.func.isRequired
              focused={this.state.retFocused} // PropTypes.bool
              onFocusChange={({ focused: retFocused }) =>
                this.setState({ retFocused })
              } // PropTypes.func.isRequired
              hideKeyboardShortcutsPanel={true}
              block={true}
              numberOfMonths={2}
              noBorder={true}
              displayFormat="ddd MMM  DD YYYY"
              placeholder={t(CHO0SE_DATE)}
              isOutsideRange={(event) => this.checkOutsideRange("ret", event)}
              anchorDirection="right"
              firstDayOfWeek={0}
            />
            <span className="mod-clear calendar">
              {/* <CalendarIcon /> */}
              {renderImg('CalendarIconBlue')}
            </span>
            <label>{` ${t(RETURN_DATE)} ${this.state.retDate ? '' : '(' + t(OPTIONAL) + ')'} `}</label>
          </div>
          <div className="mo-inp cityinput" style={{ width: '12%' }}>
            <div className="single--lady">
              <Checkbox
                onClick={() => this.state.singleLadyDisabled ? null : this.setState({ singleLady: !this.state.singleLady })}
                active={this.state.singleLady == 1}
                disabled={this.state.singleLadyDisabled == 1}
              />
              <div className="text"> {t(SINGLE_LADY)}</div>
            </div>
          </div>
          <div className="modifybutton" onClick={this.modifySrch}>
            {t(MODIFY)}
          </div>
        </div>
        <div className="darklayer"></div>
      </section>
    );
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Modify);